var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"colors-demo"}},[_c('colors-default'),_c('colors-gradient'),_c('colors-customization'),_c('colors-change-color'),_c('colors-change-color-SSR'),_c('colors-tailwind')],1)}
var staticRenderFns = []

export { render, staticRenderFns }